export const en = {
  // Main namespace - used by filter components from old app
  main: {
    titularidad: 'Ownership',
    'titularidad-privado': 'PRIVATE',
    'titularidad-publico': 'PUBLIC',
    'titularidad-municipal': 'MUNICIPAL',
    'titularidad-todo': 'ALL',
    ref_catastral_search: 'Search cadastral reference',
    ref_catastral_placeholder: 'e.g. 06001A123456789A',
    field_report: 'Field report',
    cadastral_actions_for: 'Actions for',
    cadastral_upload_pick_muni: 'Pick a municipality to upload files.',
    open_in_map: 'Open on map',
    upload_lab_measures: 'Lab sample',
    upload_field_report: 'Field report',
    field_report_details: 'Field report details',
    field_report_before_upload:
      'Before uploading, pick the element type and asbestos type you observed.',
    field_report_uploaded: 'Field report uploaded — building marked Detailed',
    upload_and_mark_detailed: 'Upload and mark Detailed',
    document_uploaded: 'Document uploaded',
    document_upload_error: 'Upload error',
    uso_del_edificio: 'Building use',
    uso_del_edificio_Industrial: 'Industrial',
    uso_del_edificio_Agrícola: 'Agricultural',
    uso_del_edificio_Retail: 'Retail',
    uso_del_edificio_Oficinas: 'Offices',
    'uso_del_edificio_Servicios Públicos': 'Public Services',
    uso_del_edificio_Residencial: 'Residential',
    uso_del_edificio_Otros: 'Others',
    asbestos_susceptibility: 'Asbestos screening',
    susceptibility_title: 'Minimum screening to contain asbestos represented',
    susceptibility_label_baja: 'Low',
    susceptibility_label_media: 'Medium',
    susceptibility_label_alta: 'High',
    susceptibility_label_muy_alta: 'Very high',
    // Map loading
    loading_boundary: 'Loading boundary...',
    public_view: 'Public view',
    municipal_boundary: 'Municipal boundary',
    // Dashboard translations
    dashboard_title: 'Asbestos Dashboard - Layer Group',
    dashboard_loading: 'Loading statistics...',
    dashboard_error_loading: 'Error loading statistics',
    dashboard_no_layer_group: 'No layer group selected',
    dashboard_tab_grid: 'GRID',
    dashboard_tab_susceptibility: 'SCREENING',
    dashboard_tab_censo: 'REMOTE DETECTION',
    dashboard_no_grid_data: 'No grid data available',
    dashboard_no_susceptibility_data: 'No screening data available',
    dashboard_no_censo_data: 'No remote detection data available',
    // Grid Dashboard
    dashboard_grid_title: 'GRID Dashboard - Time Estimation',
    dashboard_total_time: 'Total estimated processing time',
    dashboard_remaining_time: 'Remaining estimated processing time',
    dashboard_summary_by_category: 'Summary by categories',
    dashboard_cells_by_status: 'Number of cells by category and status',
    dashboard_completion_percentage: 'Project completion percentage',
    dashboard_total_cells: 'Total cells',
    dashboard_completed: 'Completed',
    dashboard_pending: 'Pending',
    // Susceptibility Dashboard
    dashboard_susceptibility_title: 'SCREENING Dashboard',
    dashboard_total_buildings: 'Total buildings',
    dashboard_unique_cadastral_refs: 'Unique cadastral refs',
    dashboard_avg_building_age: 'Avg. building age',
    dashboard_total_area_m2: 'Total area (m²)',
    dashboard_by_level: 'By screening level',
    dashboard_by_use: 'By building use',
    dashboard_by_owner: 'By ownership',
    dashboard_by_decade: 'By construction decade',
    // Censo Dashboard
    dashboard_censo_title: 'REMOTE DETECTION Dashboard',
    dashboard_total_elements: 'Total elements',
    dashboard_total_m2_amianto: 'Total m² asbestos',
    dashboard_total_m3_amianto: 'Total m³ asbestos',
    dashboard_by_asbestos_presence: 'By asbestos presence',
    dashboard_years: 'years',
    // Grid status translations
    grid_status_pending: 'Pending',
    grid_status_in_progress: 'In Progress',
    grid_status_in_review: 'In Review',
    grid_status_reviewed: 'Reviewed',
    grid_status_clear: 'Completed',
    // Susceptibility levels
    susceptibility_level_baja: 'Low',
    susceptibility_level_media: 'Medium',
    susceptibility_level_alta: 'High',
    susceptibility_level_muy_alta: 'Very High',
    // Asbestos presence
    asbestos_presence_MCA: 'MCA',
    asbestos_presence_MPCA: 'MPCA',
    asbestos_presence_NOMCA: 'NOMCA',
    asbestos_presence_MCA_desc: 'Contains asbestos',
    asbestos_presence_MPCA_desc: 'Material potentially containing asbestos',
    asbestos_presence_NOMCA_desc: 'Does not contain asbestos',
    // Common
    error: 'Error',
    otros: 'Others',
    desconocido: 'Unknown',

    // FloatingWindow translations
    selected_point: 'Selected Point',
    add_new_feature: 'Add New Feature',
    edit_feature: 'Edit Feature',
    area_properties: 'Area Properties',
    layer_groups: 'Layer Groups',
    layers: 'Layers',
    features: 'Features',
    open_in_new_tab: 'Open in new tab',
    link: 'Link',
    close: 'Close',
    read_only: 'Read only',
    read_only_mode: 'Read only mode',
    complete_previous_step: 'Complete previous step',

    // Context menu
    link_to: 'Link to...',
    change_grid_status: 'Change grid status to...',
    create_inventory_element: 'Create inventory element...',
    change_asbestos_presence: 'Change asbestos presence to...',

    // Feature property translations
    facade_photo: 'Facade photo',
    status: 'Status',
    matrix_position: 'Grid position',
    n_elements_inside: 'Elements inside',
    fx_creation: 'Creation date',
    fx_modification: 'Modification date',
    fx_pending: 'Pending date',
    fx_in_progress: 'In progress date',
    fx_review: 'Review date',
    fx_clear: 'Completed date',
    risk_final_value: 'Final risk value',
    risk_type_used: 'Risk type used',
    address: 'Address',
    owner: 'Owner',
    cadastral_ref: 'Cadastral Reference',
    ref_catastral: 'Cadastral Reference',
    inspection_type: 'Inspection Type',
    inspection_date: 'Inspection Date',
    element_type: 'Element Type',
    element_type_cubierta: 'Roof',
    element_type_fachada: 'Facade',
    element_type_chimenea: 'Chimney',
    element_type_bajantes: 'Downpipes',
    element_type_deposito: 'Tank',
    element_type_numero_de_jardineras: 'Number of planters',
    element_type_calorifugados: 'Lagging',
    element_type_suelo_vinilico: 'Vinyl flooring',
    element_type_numero_de_juntas: 'Number of joints',
    element_type_otros_elementos: 'Other elements',
    is_asbestos: 'Asbestos Presence',
    material_type: 'Material Type',
    material: 'Material',
    // Material categories
    adhesives_cements_sealants: 'Adhesives, Cements, Sealants',
    asbestos_paper_board_roll: 'Asbestos Paper, Board, Roll',
    automotive_materials_friction: 'Automotive Materials, Friction',
    cement_pipes_boards_sheets_plastics: 'Cement Pipes, Boards, Sheets, Plastics',
    clay_compounds_paints_plasters: 'Clay, Compounds, Paints, Plasters',
    electrical_mechanical_products: 'Electrical and Mechanical Products',
    flooring_tiles: 'Flooring, Tiles',
    gaskets_packings_sealing_materials: 'Gaskets, Packings, Sealing Materials',
    household_products: 'Household Products',
    panels_drywall_wall_coverings: 'Panels, Drywall, Wall Coverings',
    pipe_covering_block: 'Pipe Covering, Block',
    protective_clothing: 'Protective Clothing',
    protective_fireproof_coatings: 'Protective, Fireproof Coatings',
    raw_asbestos: 'Raw Asbestos',
    refractory_products: 'Refractory Products',
    rope_wick_cord_tape_cork: 'Rope, Wick, Cord, Tape, Cork',
    textiles_felts_fabrics: 'Textiles, Felts, Fabrics',
    // Material options - Category 1
    adhesives: 'Adhesives',
    adhesive_cement: 'Adhesive Cement',
    caulking: 'Caulking',
    cement: 'Cement',
    duct_adhesive: 'Duct Adhesive',
    finishing_cement: 'Finishing Cement',
    furnace_cement: 'Furnace Cement',
    insulating_cement: 'Insulating Cement',
    joint_cement: 'Joint Cement',
    masonry_cement: 'Masonry Cement',
    putties: 'Putties',
    mortar: 'Mortar',
    plastic_cement: 'Plastic Cement',
    sealant: 'Sealant',
    // Material options - Category 2
    asbestos_paper: 'Asbestos Paper',
    corrugated_paper: 'Corrugated Paper',
    flexible_board: 'Flexible Board',
    millboard: 'Millboard',
    permanent_board: 'Permanent Board',
    roll: 'Roll',
    vinyl_wallpaper: 'Vinyl Wallpaper',
    // Material options - Category 3
    brake_linings: 'Brake Linings',
    brake_pads: 'Brake Pads',
    brakes: 'Brakes',
    clutch_linings: 'Clutch Linings',
    disc_brakes: 'Disc Brakes',
    drum_brakes: 'Drum Brakes',
    elevator_brake_shoes: 'Elevator Brake Shoes',
    transmission_plates: 'Transmission Plates',
    // Material options - Category 4
    asbestos_board: 'Asbestos Board',
    asbestos_sheets: 'Asbestos Sheets',
    cement_pipes: 'Cement Pipes',
    plastics: 'Plastics',
    stone_coating: 'Stone Coating',
    // Material options - Category 5
    acoustic_plaster: 'Acoustic Plaster',
    asphalt: 'Asphalt',
    filler: 'Filler',
    finishing: 'Finishing',
    joint_compound: 'Joint Compound',
    paint: 'Paint',
    patching: 'Patching',
    plaster: 'Plaster',
    putty: 'Putty',
    putty_compounds: 'Putty Compounds',
    // Material options - Category 6
    boilers: 'Boilers',
    cables_wires: 'Cables and Wires',
    electrical_boards: 'Electrical Boards',
    furnaces: 'Furnaces',
    generators: 'Generators',
    heating_ducts: 'Heating Ducts',
    pumps: 'Pumps',
    turbines: 'Turbines',
    valve_rings: 'Valve Rings',
    valves: 'Valves',
    weather_resistant_jackets: 'Weather Resistant Jackets',
    wiring_insulation: 'Wiring Insulation',
    // Material options - Category 7
    ceiling_tiles: 'Ceiling Tiles',
    tiles: 'Tiles',
    flooring: 'Flooring',
    slabs: 'Slabs',
    vinyl_linoleum_floors: 'Vinyl and Linoleum Floors',
    wall_tiles: 'Wall Tiles',
    // Material options - Category 8
    braided_packing: 'Braided Packing',
    gasket_material: 'Gasket Material',
    gaskets: 'Gaskets',
    packing_material: 'Packing Material',
    rope_packing: 'Rope Packing',
    sheet_packing: 'Sheet Packing',
    // Material options - Category 9
    agricultural_filler: 'Agricultural Filler',
    attic_insulation: 'Attic Insulation',
    cigarette_filters: 'Cigarette Filters',
    clay_pots: 'Clay Pots',
    fertilizer: 'Fertilizer',
    exhaust_hoods: 'Exhaust Hoods',
    iron_stands: 'Iron Stands',
    ironing_board_covers: 'Ironing Board Covers',
    lab_hoods: 'Lab Hoods',
    potting_mixes: 'Potting Mixes',
    stove_mats: 'Stove Mats',
    // Material options - Category 10
    acoustic_panels: 'Acoustic Panels',
    drywall: 'Drywall',
    marine_panel: 'Marine Panel',
    panels: 'Panels',
    gypsum_board: 'Gypsum Board',
    wallboard: 'Wallboard',
    // Material options - Category 11
    block_insulation: 'Block Insulation',
    calcium_silicate: 'Calcium Silicate',
    duct_insulation: 'Duct Insulation',
    insulation: 'Insulation',
    magnesia: 'Magnesia',
    pipe_insulation: 'Pipe Insulation',
    preformed_pipe_wrap: 'Preformed Pipe Wrap',
    sponge_block: 'Sponge Block',
    sleeveless_jacket: 'Sleeveless Jacket',
    // Material options - Category 12
    aprons: 'Aprons',
    asbestos_helmet: 'Asbestos Helmet',
    dust_masks: 'Dust Masks',
    glassblowers_mittens: 'Glassblowers Mittens',
    gloves: 'Gloves',
    lab_gloves: 'Lab Gloves',
    mittens: 'Mittens',
    respirators: 'Respirators',
    sleeves: 'Sleeves',
    textile_garments: 'Textile Garments',
    // Material options - Category 13
    asbestos_curtains: 'Asbestos Curtains',
    asbestos_spray: 'Asbestos Spray',
    boiler_coating: 'Boiler Coating',
    fireproof_blankets: 'Fireproof Blankets',
    fire_dampers: 'Fire Dampers',
    fire_doors: 'Fire Doors',
    fireproof_cement: 'Fireproof Cement',
    fireproof_materials: 'Fireproof Materials',
    insulating_coating: 'Insulating Coating',
    roof_coating: 'Roof Coating',
    textured_coatings: 'Textured Coatings',
    coating: 'Coating',
    // Material options - Category 14
    asbestos_fiber: 'Asbestos Fiber',
    fake_snow: 'Fake Snow',
    calsilite_silicate: 'Calsilite Silicate',
    talc_powder: 'Talc Powder',
    transite: 'Transite',
    vermiculite: 'Vermiculite',
    // Material options - Category 15
    castables: 'Castables',
    refractory_brick: 'Refractory Brick',
    marinite: 'Marinite',
    refractory_cement: 'Refractory Cement',
    // Material options - Category 16
    asbestos_cord: 'Asbestos Cord',
    asbestos_rope: 'Asbestos Rope',
    cork_coating: 'Cork Coating',
    foil_rope: 'Foil Rope',
    tape: 'Tape',
    wicking: 'Wicking',
    // Material options - Category 17
    asbestos_blanket: 'Asbestos Blanket',
    asbestos_canvas: 'Asbestos Canvas',
    asbestos_fabric: 'Asbestos Fabric',
    asbestos_felt: 'Asbestos Felt',
    asbestos_lap: 'Asbestos Lap',
    asbestos_wool: 'Asbestos Wool',
    asbestos_thread: 'Asbestos Thread',
    lagging: 'Lagging',
    roving: 'Roving',
    textiles: 'Textiles',
    asbestos_type: 'Asbestos Type',
    CRISOTILO: 'Chrysotile',
    ASBESTOS: 'Asbestos',
    has_lab_measures: 'Has Lab Measurements',
    lab_measure_ref_code: 'Lab Reference Code',
    lab_measure_note: 'Lab Notes',
    risk_simplify_type: 'Simplified Risk Type',
    simple: 'Simple',
    form: 'Form',
    risk_form_value: 'Risk Form Value',
    // Risk form phases
    questionsPhase1: 'Phase 1 - Exposure',
    questionsPhase2: 'Phase 2 - Condition',
    questionsPhase3: 'Phase 3 - Friability',
    // Risk form questions and responses
    'inspections.equipmentLocation': 'Where is the material located?',
    'inspections.outdoorOrEncapsulated': 'Outdoor or encapsulated',
    'inspections.occasionallyAccessible': 'Occasionally accessible location',
    'inspections.largeAndWellVentilated': 'Large and well ventilated room (>1000m³)',
    'inspections.between2501000': 'Room between 250-1000m³',
    'inspections.lessThan250': 'Small room (<250m³)',
    'inspections.extentQuantity': 'What is the extent/quantity of material?',
    'inspections.smallQuantities': 'Small quantities (<1m²)',
    'inspections.lessThan10': 'Less than 10m²',
    'inspections.between1150': 'Between 11-50m²',
    'inspections.moreThan51': 'More than 51m²',
    'inspections.accessibility': 'What is the accessibility to the material?',
    'inspections.inaccessible': 'Inaccessible',
    'inspections.difficultyAccessible': 'Difficult to access',
    'inspections.easyAccessible': 'Easily accessible',
    'inspections.highAccessible': 'Highly accessible',
    'inspections.potentiallyExposed': 'How many people are potentially exposed?',
    'inspections.none': 'None',
    'inspections.between13': 'Between 1-3 people',
    'inspections.between410': 'Between 4-10 people',
    'inspections.moreThan10': 'More than 10 people',
    'inspections.technicalAccessibility': 'Frequency of technical access?',
    'inspections.never': 'Never',
    'inspections.occasionally': 'Occasionally',
    'inspections.frequent': 'Frequent',
    'inspections.materialStatus': 'What is the condition of the material?',
    'inspections.noDamage': 'No damage',
    'inspections.littleDamage': 'Little damage',
    'inspections.mediumDamage': 'Medium damage',
    'inspections.greatDamage': 'Severe damage',
    'inspections.asbestosVariety': 'What variety of asbestos does it contain?',
    'inspections.onlyChrysotile': 'Only chrysotile',
    'inspections.amphibolesPresence': 'Presence of amphiboles',
    'inspections.friability': 'What is the friability of the material?',
    'inspections.noFriability': 'Non-friable',
    'inspections.lowFriability': 'Low friability',
    'inspections.mediumFriability': 'Medium friability',
    'inspections.highFriability': 'High friability',
    more: 'more',
    less: 'less',
    description: 'Description',
    CUBIERTA: 'Roofing',
    PARAMENTO: 'Wall',
    BAJANTE: 'Downpipe',
    PRELIMINAR: 'Remote Detection',
    BASICO: 'Basic',
    DETALLADO: 'Detailed',
    RETIRADA: 'Removal',
    VERTIDO: 'Dump',
    surface_m2: 'Surface (m²)',
    volume_m3: 'Volume (m³)',
    notes: 'Notes',
    created_at: 'Created At',
    updated_at: 'Updated At',
    created_by: 'Created By',
    updated_by: 'Updated By',
    municipality: 'Municipality',
    province: 'Province',
    building_use: 'Building Use',
    construction_year: 'Construction Year',
    floors: 'Floors',

    // Status values
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    IN_REVIEW: 'In Review',
    REVIEWED: 'Reviewed',
    COMPLETED: 'Completed',
    CLEAR: 'Clear',

    // Asbestos presence values
    MCA: 'MCA (Contains Asbestos)',
    MPCA: 'MPCA (Potential Asbestos)',
    NOMCA: 'NOMCA (No Asbestos)',

    // Form actions
    save: 'Save',
    delete: 'Delete',
    discard: 'Discard',
    confirm_delete: 'Are you sure you want to delete this feature?',
    confirm_discard: 'Are you sure you want to discard changes?',
    save_success: 'Changes saved successfully',
    save_error: 'Error saving changes',
    delete_success: 'Feature deleted successfully',
    delete_error: 'Error deleting feature',

    // Carbon sink translations
    carbon_sink_area: 'Carbon Sink Area',
    biomass: 'Biomass',
    co2_captured: 'CO₂ Captured',
    tree_species: 'Tree Species',
    plantation_date: 'Plantation Date',

    // Image gallery translations
    ASBESTOS_INVENTORY: 'Asbestos Inventory',
    EDIFICATION_INVENTORY: 'Building Inventory',
    ASBESTOS_SUSCEPTIBILIDAD: 'Asbestos Screening',
    REMOVAL_PLAN: 'Removal Plan',
    DISPOSAL_CERTIFICATE: 'Disposal Certificate',
    no_images: 'No images',
    uploading_image: 'Uploading image',
    image_uploaded_successfully: 'Image uploaded successfully',
    deleting_image: 'Deleting image',
    image_deleted_successfully: 'Image deleted successfully',
    delete_attachment_title: 'Delete Attachment',
    delete_attachment_body: 'Are you sure you want to delete this attachment?',
    expand_image: 'Expand image',
    download_image: 'Download image',
    delete_image: 'Delete image',
    close_image: 'Close image',
    cannot_display_image: 'Cannot display image',
    show_more: 'Show more',

    // Layer types
    layer_type: 'Layer Type',
    AMIANTO_CENSO: 'Asbestos Remote Detection',
    SUSCEPTIBILIDAD: 'Screening',
    GRID: 'Grid',
    CARBON_SINK: 'Carbon Sink',

    // Susceptibility layer fields
    ine_code: 'INE Code',
    codigo_ine: 'INE Code',
    n_ref_catastral: 'Cadastral Reference Number',
    numero_referencia_catastral: 'Cadastral Reference Number',
    fecha_construccion: 'Construction Date',
    susceptibilidad: 'Asbestos Screening',
    susceptibility: 'Asbestos Susceptibility',
    uso_actual: 'Current Use',
    propietario: 'Owner',
    google_maps_link: 'Google Maps Link',
    link_maps: 'Google Maps Link',
    catastro_link: 'Cadastre Link',
    link_catastro: 'Cadastre Link',
    antiguedad: 'Building Age',
    antiguedad_edificio: 'Building Age',
    m2_catastro: 'Cadastral Square Meters',
    metros_cuadrados_catastrales: 'Cadastral Square Meters',
    provincia: 'Province',
    made_by: 'Created By',

    // Susceptibility values
    'Muy Alta': 'Very High',
    Alta: 'High',
    Media: 'Medium',
    Baja: 'Low',
    muy_alta: 'Very High',
    alta: 'High',
    media: 'Medium',
    baja: 'Low',

    // Building use values
    'Servicios Públicos': 'Public Services',
    Industrial: 'Industrial',
    Agrícola: 'Agricultural',
    Retail: 'Retail',
    Oficinas: 'Offices',
    Residencial: 'Residential',
    Otros: 'Others',

    // Owner values
    Público: 'Public',
    Privado: 'Private',
    publico: 'Public',
    privado: 'Private',

    // Document management
    documents: 'Documents',
    my_documents: 'My Documents',
    your_uploads: 'Your uploads',
    censo_amianto: 'Asbestos remote detection',
    susceptibilidad_amianto: 'Asbestos screening',
    layer_name_AMIANTO_CENSO: 'Asbestos remote detection',
    layer_name_AMIANTO_SUSCEPTIBILIDAD: 'Asbestos screening',
    edificacion: 'Building',
    lab_measures: 'Lab samples',
    LAB_MEASURES: 'Lab samples',
    upload_document: 'Upload document',
    upload_not_allowed: 'You do not have permission to upload documents',
    upload_requires_basic_permission: 'Requires basic inspection permission',
    delete_document: 'Delete document',
    download_document: 'Download document',
    no_documents: 'No documents',
    uploading_document: 'Uploading document',
    deleting_document: 'Deleting document',
    document_uploaded_successfully: 'Document uploaded successfully',
    document_deleted_successfully: 'Document deleted successfully',
    error_uploading_document: 'Error uploading document',
    error_deleting_document: 'Error deleting document',
    error_loading_documents: 'Error loading documents',
    delete_document_title: 'Delete document',
    delete_document_confirmation: 'Are you sure you want to delete the document "{{filename}}"?',
    search_documents: 'Search documents',
    search_by_cadastral: 'Search by cadastral ref.',
    search_by_municipality: 'Search by municipality',
    search_by_filename: 'Search by filename',
    filter_by_category: 'Filter by category',
    filter_by_municipality: 'Filter by municipality',
    filter_by_user: 'Filter by user',
    all_categories: 'All categories',
    filename: 'Filename',
    category: 'Category',
    size: 'Size',
    uploaded_by: 'Uploaded by',
    uploaded_at: 'Upload date',
    actions: 'Actions',
    preview: 'Preview',
    save_feature_first_to_upload_documents: 'Save the feature first to upload documents',

    // Process management (RETIRADA/VERTIDO)
    processes: 'Processes',
    removal_processes: 'Removal Processes',
    dump_processes: 'Dump Processes',
    add_process: 'Add process',
    no_processes: 'No processes',
    no_process_permissions: 'No permission to view processes',
    error_loading_processes: 'Error loading processes',

    // Process status options
    PENDIENTE: 'Pending',
    PROGRAMADA: 'Scheduled',
    EN_CURSO: 'In Progress',
    COMPLETADA: 'Completed',

    // Process priority options
    ALTA: 'High',
    MEDIA: 'Medium',
    BAJA: 'Low',

    // Process fields
    priority: 'Priority',
    scheduled_date: 'Scheduled date',
    completed_date: 'Completed date',

    // Supplier assignment (renamed from "Partner" per CEO requirement)
    assigned_supplier: 'Assigned Supplier',
    select_supplier: 'Select supplier',
    suppliers: 'Suppliers',

    // Removal-specific (RETIRADA)
    removal_plan: 'Approved removal plan',
    removal_plan_required_hint: 'Required document',
    upload_removal_plan: 'Upload removal plan',
    file_too_large: 'File is too large. Maximum size: 50 MB',
    upload_error: 'Error uploading file',
    building_permit_cost: 'Building permit cost',
    removal_cost: 'Removal cost',
    new_roofing_cost: 'New roofing cost',
    costs: 'Costs',

    // Dump-specific (VERTIDO)
    disposal_certificate: 'Landfill disposal certificate',
    disposal_certificate_required_hint: 'Required certificate from authorized landfill',
    upload_disposal_certificate: 'Upload disposal certificate',
    landfill_name: 'Landfill name',
    dump_location: 'Dump location',
    landfill_info: 'Landfill information',

    // Document upload
    replace_document: 'Replace document',
    select_file: 'Select file',
    has_document: 'Document attached',
    confirm_delete_process: 'Are you sure you want to delete this process?',

    // GeoJSON download
    download_geojson: 'Download GeoJSON',
    download_geojson_confirm_title: 'Download GeoJSON',
    download_geojson_confirm_message: 'Are you sure you want to download this GeoJSON file?',
    downloading_geojson: 'Downloading GeoJSON',
    geojson_downloaded_successfully: 'GeoJSON downloaded successfully',
    geojson_downloading_error: 'Error downloading GeoJSON',
    // Grid regeneration
    tooltipChangeGrid: 'Regenerate grid',
    regenerating_grid: 'Regenerating grid',
    grid_regenerated_successfully: 'Grid regenerated successfully',
    changing_grid_status: 'Changing grid status',
    grid_status_changed_successfully: 'Grid status changed successfully',
    grid_status_change_error: 'Error changing grid status',
    no_grid_to_update: 'No grid cell to update',
    from_layer: 'From layer',
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    name_en: 'Name (EN)',
    name_es: 'Name (ES)',
    name_pt: 'Name (PT)',
    // Fotointerpretation mode
    tooltipTeledeteccion: 'Photointerpretation mode',
    tooltipFieldMode: 'Field inspection mode (tablet)',
    interpretation_enter: 'Interpretation',
    interpretation_active: 'Interpretation on',
    interpretation_exit: 'Exit interpretation',
    field_mode_enter: 'Field mode',
    field_mode_active: 'Field mode on',
    field_mode_exit: 'Exit field mode',
    exit_edition: 'Exit photointerpretation',
    // Map controls
    zoom_in: 'Zoom in',
    zoom_out: 'Zoom out',
    center_aoi: 'Center on municipality',
    center_user: 'My location',
    reset_rotation: 'Reset rotation',
    expand_map: 'Expand map',
    collapse_map: 'Collapse map',
    fullscreen: 'Fullscreen',
    exit_fullscreen: 'Exit fullscreen',
    open_settings: 'Map settings',
    toggle_snap_guides: 'Toggle snap guides',
    print: 'Print map',
    locating: 'Locating...',
    exit_draw_polygon_mode: 'Exit draw mode',
    copying_element: 'Copying element',
    element_copied_successfully: 'Element copied successfully',
    element_copying_error: 'Error copying element',
    element_selected: 'Element selected',
    no_inventory_layer: 'Remote detection layer not found',
    creating_new_element: 'Creating new element',
    element_created_successfully: 'Element created successfully',
    element_creating_error: 'Error creating element',
    updating_element: 'Updating element',
    element_updated_successfully: 'Element updated successfully',
    element_updating_error: 'Error updating element',
  },
  translation: {
    common: {
      yes: 'Yes',
      no: 'No',
      connect: 'Connect',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      success: 'Success',
      error: 'Error',
    },
    error: { generic: 'Something went wrong' },
    user: {
      user_one: 'User',
      user_other: 'Users',
      notFound: 'User not found',
      fullName: 'Full name',
      email: 'Email',
      phone: 'Phone',
      username: 'Username',
      createdAt: 'Created at',
      scope: 'Scope',
      primaryContact: 'Primary contact',
      status: { active: 'Active', inactive: 'Inactive' },
      details: {
        roles: 'Roles',
        invitePermissions: 'Invite permissions',
        accessPermissions: 'Access permissions',
        accessHint: 'Permissions are read-only.',
      },
      // User management actions
      actions: 'Actions',
      management: 'User Management',
      deactivate: 'Deactivate user',
      activate: 'Activate user',
      deactivated: 'User deactivated',
      activated: 'User activated',
      setPrimary: 'Set as primary contact',
      setPrimarySuccess: 'User set as primary contact',
      noRoles: 'No roles',
      noInvitePerms: 'No invite permissions',
      // Profile editing
      editProfile: 'Edit profile',
      profileUpdated: 'Profile updated',
      emailNotEditable: 'Email cannot be changed',
      // Password change
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      passwordChanged: 'Password changed successfully',
      passwordMinLength: 'Password must be at least 8 characters',
      passwordMismatch: 'Passwords do not match',
    },
    permissions: {
      action: { view: 'View', edit: 'Edit' },
      level: {
        basic: 'basic',
        detailed: 'detailed',
        preliminary: 'remote detection',
        dump: 'dump',
        removal: 'removal',
      },
    },
    entities: {
      municipality_one: 'Municipality',
      municipality_other: 'Municipalities',
      organization_one: 'Organization',
      organization_other: 'Organizations',
      partner_one: 'Supplier',
      partner_other: 'Suppliers',
      global_one: 'Admin',
    },
    supplier: {
      actions: 'Actions',
      management: 'Supplier Management',
      deactivate: 'Deactivate supplier',
      activate: 'Activate supplier',
      deactivated: 'Supplier deactivated',
      activated: 'Supplier activated',
      disconnect: 'Disconnect',
      disconnected: 'Supplier disconnected',
      deactivateConfirm: {
        title: 'Deactivate supplier',
        message: 'Are you sure you want to deactivate {{name}}?',
      },
      activateConfirm: {
        title: 'Activate supplier',
        message: 'Are you sure you want to activate {{name}}?',
      },
      disconnectConfirm: {
        title: 'Disconnect supplier',
        message:
          'Are you sure you want to disconnect {{name}} from this municipality? This will terminate the contract.',
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
      },
    },
    municipality: {
      deactivate: 'Deactivate',
      activate: 'Activate',
      deactivated: 'Municipality deactivated',
      activated: 'Municipality activated',
      deactivateConfirm: {
        title: 'Deactivate municipality',
        message:
          'Are you sure you want to deactivate {{name}}? Users will no longer be able to access this municipality.',
      },
      activateConfirm: {
        title: 'Activate municipality',
        message: 'Are you sure you want to activate {{name}}?',
      },
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    partnerConnection: {
      connectPartnerToMunicipality: 'Connect supplier to municipality',
      connectingPartner: 'Connecting supplier',
      selectMunicipality: 'Select municipality',
      partnerConnectedSuccessfully: 'Supplier connected successfully',
      errorConnectingPartner: 'Error connecting supplier',
    },
    orgManagement: {
      actions: 'Actions',
      management: 'Organization Management',
      edit: 'Edit organization',
      updated: 'Organization updated',
    },
    entity: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      website: 'Website',
      cif: 'CIF',
      ine: 'INE',
      realIne: 'Real INE',
      realIneDescription: 'If set, indicates the INE code is synthetic',
      syntheticIne: 'Synthetic INE.',
      razonSocial: 'Business Name',
      actions: 'Actions',
      management: 'Management',
      edit: 'Edit',
      updated: 'Entity updated',
      warning: {
        oneTime: '* Can only be changed once. To modify it later, contact an administrator.',
      },
      accessDenied: 'You do not have access to this entity',
      loadError: 'Error loading entity',
    },
    logs: {
      title: 'System Logs',
      noFiles: 'No log files found',
      lines: 'Lines',
      empty: '(empty file)',
      loadError: 'Error loading file',
      selectFile: 'Select a log file to view',
    },
    muniStats: {
      title: 'Statistics',
      gridCompletion: 'Grid Inspection',
      completedCells: 'cells completed',
      censoInventory: 'Remote detection inventory',
      buildings: 'buildings',
      m2Asbestos: 'm² asbestos',
      asbestosPresence: 'Asbestos Presence',
      processes: 'Processes',
      noData: 'No data',
      processStatus: {
        PENDIENTE: 'Pending',
        PROGRAMADA: 'Scheduled',
        EN_CURSO: 'In Progress',
        COMPLETADA: 'Completed',
      },
    },
    login: {
      welcome: 'Welcome',
      subtitle: 'Sign in to continue',
      email: 'Email',
      emailPlaceholder: 'you@email.com',
      password: 'Password',
      passwordPlaceholder: '••••••••',
      button: 'Sign in',
      loading: 'Signing in...',
      backToMap: '← Back to public map',
      footer: 'Asbestos management platform',
      forgotPassword: 'Forgot your password?',
      invalidCredentials: 'Invalid credentials',
      noRoles: 'No roles assigned to your account',
      deactivated: 'Your municipality has been deactivated. Contact your administrator.',
      error: 'Login failed',
    },
    forgotPassword: {
      title: 'Reset password',
      subtitle: 'We will send you instructions by email',
      email: 'Email',
      emailPlaceholder: 'you@email.com',
      button: 'Send instructions',
      loading: 'Sending...',
      backToLogin: '← Back to login',
      successMessage: 'If the email exists, you will receive instructions to reset your password.',
      error: 'An error occurred. Please try again.',
    },
    resetPassword: {
      title: 'New password',
      password: 'New password',
      passwordPlaceholder: '••••••••',
      confirmPassword: 'Confirm password',
      confirmPasswordPlaceholder: '••••••••',
      hint: 'Password must be at least 8 characters',
      button: 'Update password',
      loading: 'Updating...',
      verifying: 'Verifying link...',
      invalidToken: 'Invalid or expired link',
      requestNew: 'Request a new link',
      successMessage: 'Your password has been successfully updated.',
      goToLogin: 'Go to login',
      minLength: 'Password must be at least 8 characters',
      mismatch: 'Passwords do not match',
    },
    register: {
      userInfo: 'User Information',
      registerEntity: 'Register {{entity}}',
      loading: 'Creating account...',
      submit: 'Register',
      inviteNotFound: 'Invite not found',
      success: 'Registered successfully',
      failure: 'Could not complete registration',
    },
    header: {
      profile: 'Profile',
      logout: 'Logout',
      language: 'Language',
      open_invites: 'Open Invites',
      my_documents: 'My Documents',
      logs: 'System Logs',
      user_manual: 'User Manual',
    },
    footer: {
      privacy: 'Privacy and cookie policy',
      legal: 'Legal notice',
      euAlt: 'Government of Spain',
    },
    breadcrumbs: {
      dashboard: 'Dashboard',
      profile: 'Profile',
      my_documents: 'My Documents',
    },
    report: {
      title: 'Send Feedback',
      tooltip:
        'Share ideas, suggestions or issues. A screenshot of the current view can be included.',
      comment: 'Comment',
      comment_placeholder: 'Describe your idea, suggestion or issue...',
      send: 'Send',
      discard: 'Discard',
      success: 'Feedback sent',
      error: 'Could not send feedback',
    },
    dashboard: {
      organizations: 'Organizations',
      municipalities: 'Municipalities',
      partners: 'Suppliers',
      myEntity: 'My Entity',
      my: 'My',
    },
    entityForm: {
      userEmail: "User's email",
      primaryUserEmail: "Primary user's email",
      name: 'Name',
      namePlaceholder: 'Entity name',
      email: 'Email',
      emailPlaceholder: 'Entity email',
      phoneNumber: 'Phone number',
      phoneNumberPlaceholder: 'Entity phone number',
      address: 'Address',
      addressPlaceholder: 'Entity address',
      website: 'Website',
      websitePlaceholder: 'Entity website URL',
      cif: 'CIF',
      cifPlaceholder: 'CIF (9 characters)',
      razonSocial: 'Business Name',
      razonSocialPlaceholder: 'Business name',
      ineCode: 'INE Code',
      ineCodePlaceholder: 'INE code (5 characters)',
      municipalities: 'Municipalities',
      municipalitiesPlaceholder: 'Select municipalities',
      contractStart: 'Contract Start',
      contractStartPlaceholder: 'YYYY-MM-DD',
      contractEnd: 'Contract End',
      contractEndPlaceholder: 'YYYY-MM-DD',
      contractDocument: 'Contract Document',
      uploadContract: 'Upload Contract',
      loading: 'Creating entity...',
      submit: 'Create Entity',
      passwordMismatch: 'Passwords do not match',
      firstName: 'First Name',
      firstNamePlaceholder: 'Enter your first name',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Enter your last name',
      userPhoneNumber: 'Phone Number',
      userPhoneNumberPlaceholder: 'Enter your phone number',
      username: 'Username',
      usernamePlaceholder: 'Choose a username (optional)',
      password: 'Password',
      passwordPlaceholder: 'Enter your password',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Re-enter your password',
      secondLastName: 'Second Last Name',
      secondLastNamePlaceholder: 'Enter your second last name',
      cifError: 'CIF must be exactly 9 characters',
      ineError: 'INE code must be exactly 5 characters',
    },
    list: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      website: 'Website',
      ine: 'INE',
      razonSocial: 'Business Name',
      cif: 'CIF',
      firstName: 'First name',
      lastName: 'Last name',
      secondLastName: 'Second last name',
      phoneNumber: 'Phone number',
      isActive: 'Is active',
      isPrimaryContact: 'Is primary contact',
      username: 'Username',
      createdAt: 'Active since',
      inviterEmail: 'Invited by',

      id: 'ID',
      inviterFullName: 'Inviter Full Name',
      scopeType: 'Type',
      scopeId: 'Scope ID',
      targetName: 'Target',
      scopeName: 'Invited Name',
      roles: 'Roles',
      municipalityIds: 'Municipality IDs',
      municipalityNames: 'Municipality Names',
      status: 'Status',
      contractStatus: 'Contract',
      expiresAt: 'Expires At',
    },
    listPage: {
      invalidEntityType: 'Invalid entity type',
      list: 'List',
      cards: 'Cards',
      add: 'Add',
      create: 'Create',
      filterByName: 'Filter by name...',
      filterByIne: 'Filter by INE...',
      filterByRazonSocial: 'Filter by razón social...',
      entityType: {
        orgs: 'Organization',
        munis: 'Municipality',
        partners: 'Supplier',
      },
    },
    usersList: {
      search: 'Search users...',
    },
    entityTabs: {
      organization: 'Organization',
      municipalities: 'Municipalities',
      partners: 'Suppliers',
      contracts: 'Contracts',
      noOrgLoaded: 'No organization loaded',
      close: 'Close',
      map: 'Map',
      documents: 'Documents',
      connectToMunicipality: 'Connect to Municipality',
      users: 'Users',
      notifications: 'Notifications',
    },
    contracts: {
      partner: 'Supplier',
      municipality: 'Municipality',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status',
      actions: 'Actions',
      noContracts: 'No contracts found',
      noContract: 'No contract',
      active: 'Active',
      expired: 'Expired',
      upcoming: 'Upcoming',
      viewDocument: 'View document',
      downloadDocument: 'Download document',
      disconnect: 'Disconnect partner',
      disconnectTitle: 'Disconnect partner',
      disconnectConfirmation:
        'Are you sure you want to disconnect {{partner}} from {{municipality}}?',
      disconnected: 'Partner disconnected successfully',
      disconnectError: 'Error disconnecting partner',
    },
    actions: 'Actions',
    organization: 'Organization',
    partner: 'Supplier',
    plural: {
      organization: 'Organizations',
      municipality: 'Municipalities',
      partner: 'Suppliers',
    },
    noDataAvailable: 'No data available',
    roles: {
      admin_full: 'Administrator — full access',
      admin_prelim: 'Administrator — remote detection only',
      org_user_admin: 'Organization admin',
      org_user_basic_ins: 'Organization user — basic inspection',
      org_user_detailed_ins: 'Organization user — detailed inspection',
      org_user: 'Organization user',
      municipality_user_admin: 'Municipality admin',
      municipality_user: 'Municipality user',
      partner_user_admin: 'Supplier admin',
      partner_user: 'Supplier user',
      partner_user_dump: 'Supplier user — dump operations',
      partner_user_removal: 'Supplier user — removal operations',
      partner_user_detailed_ins: 'Supplier user — detailed inspection',
    },
    invites: {
      success: 'Invitation sent successfully',
      failure: 'An error occurred',
      title: 'Invites',
      decline: {
        decline: 'Decline',
        success: 'Invitation declined',
        error: 'Could not decline invitation, please try again',
        confirm: {
          title: 'Decline invitation',
          message: 'Are you sure you want to decline this invitation for {{email}}?',
          ok: 'Decline',
          cancel: 'Cancel',
        },
      },
    },
    // Filter panel translations
    no_filterable_layers: 'No filterable layers available',
    select_layer_to_filter: 'Select layer to filter',
    select_layer: 'Select layer',
    // Layer panel translations
    layer_panel: 'Layer panel',
    layer_control: 'Layer control',
    panel_close: 'Close',
    collapse_panel: 'Collapse panel',
    expand_panel: 'Expand panel',
    tab_visualization: 'Visualization',
    tab_filters: 'Filters',
    tab_dashboard: 'Dashboard',
    no_layers_available: 'No layers available',
    layers_count: '{{count}} layer groups',
    filters_placeholder: 'Filters will be configured here',
    dashboard_placeholder: 'Dashboard will be displayed here',
    opacity: 'Opacity',
    style: 'Style',
    visualization_selector: 'Visualization',
    legend: 'Legend',
    loading_legend: 'Loading legend',
    legend_unavailable: 'Legend unavailable',
    toggle_visibility: 'Toggle visibility',
    // Base map layer translations
    base_layer_selector: 'Base layers',
    pnoa_title: 'PNOA Aerial',
    pnoa_description: 'Spanish aerial imagery (PNOA)',
    osm_title: 'OpenStreetMap',
    osm_description: 'Community-built street map',
    catastro_title: 'Cadastre',
    catastro_description: 'Spanish cadastral parcels',
    zonas_catastro_title: 'Cadastre + Aerial',
    zonas_catastro_description: 'Cadastral zones over aerial imagery',
    cyclosm_title: 'CyclOSM',
    cyclosm_description: 'Cycling-oriented topographic map',
    google_satellite_title: 'Google Satellite',
    google_satellite_description: 'Google satellite imagery',
    // ...other global translations...
    // Public Report Page
    publicReport: {
      title: 'Report Asbestos Location',
      step1Label: 'Location',
      step1Description: 'Location information',
      step2Label: 'Contact',
      step2Description: 'Contact details (optional)',
      municipality: 'Municipality',
      selectMunicipality: 'Select municipality',
      location: 'Map location (optional)',
      clickToSelect: 'Click on the map to select a location',
      address: 'Address',
      addressPlaceholder: 'Enter the address or description of the location',
      cadastralRef: 'Cadastral reference',
      cadastralRefPlaceholder: 'e.g.: 0035603VF6703S0001',
      message: 'Description',
      messagePlaceholder: 'Describe the situation of the asbestos detected',
      messageMinLength: 'Description must be at least 10 characters',
      images: 'Photos',
      imagesHelp: '{{count}} of {{max}} images (minimum 1 required)',
      photos: 'Photos',
      optional: 'optional',
      uploadPhoto: 'Upload photo',
      name: 'Name',
      namePlaceholder: 'Your name (optional)',
      email: 'Email',
      emailPlaceholder: 'Your email (optional)',
      phone: 'Phone',
      phonePlaceholder: 'Your phone (optional)',
      contactOptional: 'Contact details are optional but facilitate tracking your report.',
      contactOptionalLabel: 'Contact details (optional)',
      dataProtection:
        'I accept the data protection policy and the processing of my data to manage this report.',
      back: 'Back',
      next: 'Next',
      submit: 'Submit report',
      submittingTitle: 'Submitting report...',
      successTitle: 'Report submitted successfully',
      successMessage:
        'Thank you for your report. The municipality has been notified and will review the information provided.',
      successSubtitle:
        'If you provided an email, you will receive updates on the status of your report.',
      submitAnother: 'Submit another report',
      errorTitle: 'Error',
      errorSubmitting: 'Could not submit the report. Please try again.',
      errorLoadingMunicipalities: 'Could not load municipalities',
      invalidEmail: 'Please enter a valid email address',
      invalidPhone: 'Please enter a valid phone number',
    },
    // Public Map Page
    publicMap: {
      title: 'Asbestos Map',
      login: 'Login',
      searchPlaceholder: 'Search municipality...',
      typeToSearch: 'Type at least 2 characters to search',
      noResults: 'No results',
      selectedMunicipality: 'Selected:',
      clickToReport: 'Click on the map to mark a location',
      noAoiTitle: 'No boundaries available',
      noAoiMessage: 'This municipality does not have geographic data available.',
      outsideBoundaryTitle: 'Outside boundary',
      outsideBoundaryMessage: 'Please click within the selected municipality boundary.',
      legend: 'Legend',
      asbestosInventory: 'Asbestos inventory',
      municipalityBoundary: 'Municipality boundary',
      reportTitle: 'Select a location on the map to continue',
      coordinates: 'Coordinates',
    },
    // Notification Recipients Panel
    notificationRecipients: {
      title: 'Notification Recipients',
      description:
        'Manage email addresses that will receive public asbestos reports for this municipality.',
      recipientsCount: 'recipients',
      email: 'Email',
      emailPlaceholder: 'name@example.com',
      name: 'Name',
      namePlaceholder: 'Name (optional)',
      status: 'Status',
      actions: 'Actions',
      add: 'Add',
      active: 'Active',
      inactive: 'Inactive',
      noRecipients: 'No recipients configured. Add email addresses to receive public reports.',
      added: 'Recipient added successfully',
      deleted: 'Recipient deleted',
      errorLoading: 'Could not load recipients',
      errorAdding: 'Could not add recipient',
      errorDeleting: 'Could not delete recipient',
      errorToggling: 'Could not change recipient status',
    },
  },
}
